export const TOKEN= "TOKEN";
export const LOADER_ACTION = "LOADER_ACTION";
export const LOGOUT = "LOGOUT";
export const SET_USER_TYPE = "SET_USER_TYPE";
export const SET_SUMMARY_DETAILS = "SET_SUMMARY_DETAILS";